import React, { Component } from 'react';
import clsx from 'clsx';

import { IsActionPermitted } from 'containers';

import styles from './Actions.scss';

export default class Actions extends Component {
  static defaultProps = [];

  renderAction = ({ label, type, permissions }, index) => {
    const { data, onSelect } = this.props;
    return (
      <IsActionPermitted
        key={index}
        permissions={permissions}
        className={styles.actionItemWrapper}
      >
        {(isPermitted) => (
          <div
            onKeyPress={
              isPermitted ? () => onSelect(data.rowData, type) : undefined
            }
            onClick={
              isPermitted ? () => onSelect(data.rowData, type) : undefined
            }
            className={clsx(
              styles.actionItem,
              !isPermitted && styles.actionItem__disabled,
            )}
            role="presentation"
            data-testid="PlatformAdminUI-TableRenderers-ActionsLabel"
          >
            {label}
          </div>
        )}
      </IsActionPermitted>
    );
  };

  render() {
    const { actions } = this.props;

    return (
      <div className={styles.actions}>{actions.map(this.renderAction)}</div>
    );
  }
}
